import { MEDIA_SIZE_LARGE } from '@/media/constants/sizeCodes';
import { MEDIA_SIZE_MAP } from '@/media/constants/sizeCodeToPx';
import { getFrameUrl } from '@/media/helpers/getFrameUrl';

import Media from '../entity/Media';

export class PreviewService {
  static getMediaPreviewUrl(media: Nullable<Media>): Nullable<string> {
    if (!media) {
      return null;
    }

    const mainMediaSource = media.mainMediaSource;

    if (!mainMediaSource) {
      return null;
    }

    const maxSubFile = mainMediaSource.getMaxSubFileByMediaSize(MEDIA_SIZE_MAP[MEDIA_SIZE_LARGE]);

    if (!maxSubFile) {
      return null;
    }

    if (media.isImage) {
      return maxSubFile.externalLink;
    }

    return getFrameUrl(maxSubFile);
  }

  static async fetchPreviewFile(
    previewUrl: string,
    signal?: AbortSignal,
    fileName = 'preview.jpg',
  ): Promise<Nullable<File>> {
    try {
      const response = await fetch(previewUrl, { signal });
      const blob = await response.blob();

      return new File([blob], fileName, { type: blob.type });
    } catch (e) {
      console.warn(e);

      return null;
    }
  }
}
